import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家財アイテム用 オプションサービスマスタ
 */
export const yhc_kazai_option_services: ModelDef = {
  tableName: 'yhc_kazai_option_services',
  tableLabel: '見積:家財アイテム用 オプションサービスマスタ',
  primaryKeyColType: 'NUMBER',
  replicable: true,
  columns: {
    admin_title: {
      type: 'STRING',
      label: '管理用名称',
      replicable: true,
      validate: { notEmpty: true },
    },
    description: {
      type: 'STRING',
      label: '説明文',
      replicable: true,
      validate: { notEmpty: true },
      width: { xs: 36 },
      inputHelpText:
        '家財ごとオプションの説明文です。\n例：分解・組み立てを行う場合は選択してください。',
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
    isEnabledOnDebug: {
      type: 'BOOLEAN',
      label: '開発プレビューで表示',
      replicable: true,
    },
    selectionType: {
      type: 'BOOLEAN',
      label: '単一選択 or 複数選択可',
      replicable: true,
      defaultValue: true,
      validate: { notEmpty: true },
      inputComponent: 'BooleanRadioInput',
      inputAttrs: {
        trueLabel: '単一選択のみ',
        falseLabel: '複数選択可',
      },
      inputHelpText:
        '選択肢のうち単一選択のみ許可するか、複数選択を可能とするか。\n例：ベッドの"分解" "組み立て" が選択肢となる場合、それぞれ選択可能なので"複数選択可"となる',
    },
    originService: {
      type: 'MULTISELECT',
      label: '利用元サービス',
      replicable: true,
      inputComponent: 'MultiselectCheckboxesInput',
      selections: () => ['家財宅急便', 'ちょこっと模様替え'],
    },
    notice: {
      type: 'RICHTEXT',
      label: '注意事項',
      replicable: true,
      width: { xs: 48 },
      inputHelpText: 'オプション選択の下部に表示される注意事項文章です。',
    },
    selections: {
      type: 'ARRAY_OF_OBJECT',
      label: '選択肢',
      replicable: true,
      width: { xs: 48 },
      validate: {
        atLeastOneSelection: (value) =>
          value?.length > 0 ? '' : '1つ以上の選択肢を入力して下さい',
      },
      columns: {
        title: {
          type: 'STRING',
          label: '表示名',
          validate: { notEmpty: true },
        },
        price: {
          type: 'NUMBER',
          label: 'オプション料金',
          validate: { notEmpty: true },
        },
        enabledFrom: {
          type: 'DATETIME',
          label: '有効期間 開始',
          validate: { notEmpty: true },
        },
        disabledAt: {
          type: 'DATETIME',
          label: '有効期間 終了',
          validate: { notEmpty: true },
        },
        availableDeliveryArea: {
          type: 'MULTISELECT',
          label: '利用可能配達エリア',
          validate: { notEmpty: true },
          selections: () => [
            { label: 'YHC提供エリア', value: '1' },
            { label: 'YTC提供エリア', value: '0' },
            { label: 'YTC提供 特殊家財配達不能エリア', value: '2' },
            { label: '家財配達不能エリア', value: '3' },
          ],
        },
        areaRestrictionType: {
          type: 'STRING',
          label: '利用するのはお預かり先・お届け先いずれか',
          validate: { notEmpty: true },
          selections: () => [
            { label: 'お預かり先', value: 'fromArea' },
            { label: 'お届け先', value: 'toArea' },
            { label: '両方', value: 'bothArea' },
          ],
        },
      },
    },
  },
}
